import Button from '@restart/ui/esm/Button'
import React, { useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import { useDispatch } from 'react-redux'
import { fetchNewProduct } from '../../../redux/action/product/product'
import { useTranslation } from 'react-i18next'
import { fetchCsrfCookie } from '../../../redux/action/csrf/csrf-cookie'

const CreateNewProduct = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const [data, setData] = useState({
        name: "",
        brand: "",
        unit: "",
        price: "",
        sell_price: "",
        category_id: props.id,
    })

    const changeHandler = event => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const reset = () => {
        setData({
            ...data,
            name: "",
            brand: "",
        })
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است",
          min: " تعداد کاراکترهای ورودی کم است " ,
          email: " محتوای ورودی صحیح نیست "
        },
    }))

    const createProduct = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            dispatch(fetchCsrfCookie())
            dispatch(fetchNewProduct(data))
            props.update()
            reset()
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right'})
        }
    }

    return (
        <>
            <DashboardMainTitle> {t("dashboard_nav_create_product")} </DashboardMainTitle>
            <div className="form-container mb-4">
                <Form onSubmit={e => createProduct(e)}>
                    <Form.Group className="mb-3 col-md-5" controlId="name">
                        <Form.Label>{t("title")} :</Form.Label>
                        <Form.Control type="text"  name="name" value={data.name} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('name', data.name, 'required')}</span>
                    </Form.Group>

                    <Form.Group className="mb-3 col-md-5" controlId="brand">
                        <Form.Label> {t("brand")} : </Form.Label>
                        <Form.Control type="text" name="brand" value={data.brand} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('brand', data.brand, 'required')}</span>
                    </Form.Group>

                    <Form.Group className="mb-3 col-md-5" controlId="unit">
                        <Form.Label> {t("product_unit")} : </Form.Label>
                        <Form.Control type="number" min={0} name="unit" value={data.unit} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('unit', data.unit, 'required')}</span>
                    </Form.Group>

                    <Form.Group className="mb-3 col-md-5" controlId="price">
                        <Form.Label> {t("product_price")} : </Form.Label>
                        <Form.Control type="text" name="price" value={data.price} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('price', data.price, 'required')}</span>
                    </Form.Group>

                    <Form.Group className="mb-3 col-md-5" controlId="sell_price">
                        <Form.Label> {t("product_selling_price")} : </Form.Label>
                        <Form.Control type="text" name="sell_price" value={data.sell_price} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('sell_price', data.sell_price, 'required')}</span>
                    </Form.Group>

                    <Button variant="primary" type="submit" className="btn green-btn mt-3" disabled={btnLoading ? true : false}>
                        {t("create")}
                    </Button>
                </Form>
            </div>
        </>
    )
}

export default CreateNewProduct
